import { PublicKey } from '@solana/web3.js';
import { OperationUnauthorizedForGuestsError } from '../../errors/SdkError.mjs';

class GuestIdentityDriver {
  constructor(publicKey) {
    this.publicKey = publicKey ?? PublicKey.default;
  }
  async signMessage() {
    throw new OperationUnauthorizedForGuestsError('signMessage');
  }
  async signTransaction() {
    throw new OperationUnauthorizedForGuestsError('signTransaction');
  }
  async signAllTransactions() {
    throw new OperationUnauthorizedForGuestsError('signAllTransactions');
  }
}

export { GuestIdentityDriver };
//# sourceMappingURL=GuestIdentityDriver.mjs.map
